import React from 'react';

import { CircularButton, Typography } from '@hpi-sox/hpstellar-core';

import './game-card.less';

export default function GameCard({ name, imageUrl, fps, onToggle, selected, disable }) {
    const toggleSelect = () => {
        if (disable) return;
        onToggle();
    };

    return (
        <div
            className={`gameCardContainer${selected ? ' selected' : ''}${imageUrl ? '' : ' noImg'}${
                disable && !selected ? ' disable' : ''
            }`}
            onClick={toggleSelect}
        >
            <div className="imgContainer">
                {imageUrl ? <img src={imageUrl} alt={name} /> : <div className="fpsImgGradient" />}
                <div className="imgButton">
                    <CircularButton icon={selected ? 'cross' : 'plus'} useTransparentBg />
                    <Typography variant="boldXS">{selected ? 'REMOVE' : 'ADD GAME'}</Typography>
                </div>
            </div>
            <div className="desc">
                <Typography className="gameName" variant="boldS" title={name}>
                    {name}
                </Typography>
                <Typography className="fpsValue" variant="bodyXS">
                    {fps}
                </Typography>
            </div>
        </div>
    );
}
